import React from 'react';
import { TimerCardSkeleton } from './blocks';

const TimerDetailSkeleton: React.FC = () => <TimerCardSkeleton />;

export default TimerDetailSkeleton;
